import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { LicenseInfo } from '@mui/x-license'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { PageHistoryManager } from 'wdc-cube-react'
import { registerViews as registerWaitingViews } from './components/waiting/views'
import { buildCube } from './Cube'
import { MainPresenter } from './main'
import { MainView, registerViews as registerMainViews } from './main/views'
import { registerViews as analiseFormViews } from './modules/analise/form/views'
import { registerViews as condicaoFormViews } from './modules/analise/regra/condicao/views'
import { registerViews as regraFormViews } from './modules/analise/regra/views'
import { registerViews as analiseSelectViews } from './modules/analise/select/views'
import { registerViews as analiseViews } from './modules/analise/views'
import { registerViews as borderoFormViews } from './modules/bordero/form/views'
import { registerViews as dialogoResultadoView } from './modules/bordero/resultado-detalhado/dialogo-resultado/views'
import { registerViews as resultadoDetalhadoAnaliseVisaoCedenteViews } from './modules/bordero/resultado-detalhado/views'
import { registerViews as resultadoAnaliseViews } from './modules/bordero/resultado/views'
import { registerViews as statusProcessamentoViews } from './modules/bordero/status-processamento/views'
import { registerViews as borderoViews } from './modules/bordero/views'
import { registerViews as grupoFormViews } from './modules/grupo/form/views'
import { registerViews as grupoViews } from './modules/grupo/views'
import { registerViews as integracaoMonitoramentoFormViews } from './modules/integracao/form/views'
import { registerViews as resultadoAnaliseVisaoCedenteViews } from './modules/integracao/resultado/views'
import { registerViews as integracaoMonitoramentoViews } from './modules/integracao/views'
import { registerViews as pfViews } from './modules/pf/views'
import { registerViews as pjViews } from './modules/pj/views'
import { registerViews as registerRestrictedViews } from './modules/restricted/views'
import { registerViews as serasaHistoryViews } from './modules/serasa-history/views'
import { registerViews as serasaViews } from './modules/serasa/views'
import { registerViews as serproViews } from './modules/serpro/views'

import { LocaleProvider } from 'src/utils/views'
import { MuiTheme } from './theme'

LicenseInfo.setLicenseKey(
    'e6e2a927329dbfd9e981659d8bcd9994Tz05NDUzNSxFPTE3NTI5NDkwMDcwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
)

registerWaitingViews()
registerMainViews()
registerRestrictedViews()
pjViews()
pfViews()
serasaViews()
serasaHistoryViews()
serproViews()
grupoViews()
grupoFormViews()
analiseViews()
analiseFormViews()
regraFormViews()
condicaoFormViews()
analiseSelectViews()
borderoViews()
borderoFormViews()
integracaoMonitoramentoViews()
integracaoMonitoramentoFormViews()
resultadoAnaliseVisaoCedenteViews()
resultadoAnaliseViews()
statusProcessamentoViews()
resultadoDetalhadoAnaliseVisaoCedenteViews()
dialogoResultadoView()
buildCube()

const historyManager = new PageHistoryManager(true)

function App() {
    const presenter = React.useMemo(() => new MainPresenter(historyManager), [])

    React.useEffect(() => {
        const handleOnComponentWillUnmount = presenter.initialize()
        return () => {
            handleOnComponentWillUnmount()
        }
    }, [presenter])

    const locale = LocaleProvider.get()
    //adapterLocale={locale.fns}

    return (
        <MuiTheme>
            <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="pt-br"
                localeText={locale.mui.components.MuiLocalizationProvider.defaultProps.localeText}
            >
                <MainView scope={presenter.scope} />
            </LocalizationProvider>
        </MuiTheme>
    )
}

const container = document.getElementById('root')
if (container) {
    const root = createRoot(container)
    root.render(<App />)
}
